"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntelligentHubApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var IntelligentHubApi = /** @class */ (function (_super) {
    __extends(IntelligentHubApi, _super);
    function IntelligentHubApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntelligentHubApi.prototype.intelligentHubBlobsCreateBlobDownloadSasUrlsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerCreateBlobDownloadSasUrlsRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerCreateBlobDownloadSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Blobs/CreateBlobDownloadSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerCreateBlobDownloadSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubBlobsCreateBlobUploadSasUrlsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerCreateBlobUploadSasUrlsRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerCreateBlobUploadSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Blobs/CreateBlobUploadSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerCreateBlobUploadSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubBlobsDeleteBlobsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerDeleteBlobsRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerDeleteBlobsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Blobs/DeleteBlobs',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerDeleteBlobsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubBlobsGetBlobUploadHistoryPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetBlobUploadHistoryRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetBlobUploadHistoryRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Blobs/GetBlobUploadHistory',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetBlobUploadHistoryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubBlobsRecordBlobUploadHistoryPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerRecordBlobUploadHistoryRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerRecordBlobUploadHistoryRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Blobs/RecordBlobUploadHistory',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerRecordBlobUploadHistoryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsCalculateFileDocumentStatisticsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerCalculateFileDocumentStatisticsRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerCalculateFileDocumentStatisticsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/CalculateFileDocumentStatistics',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerCalculateFileDocumentStatisticsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsCalculateRemainingPagesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerCalculateRemainingPagesRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerCalculateRemainingPagesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/CalculateRemainingPages',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerCalculateRemainingPagesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsCreateFileDocumentPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerCreateFileDocumentRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerCreateFileDocumentRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/CreateFileDocument',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerCreateFileDocumentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsDeleteFileDocumentPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerDeleteFileDocumentRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerDeleteFileDocumentRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/DeleteFileDocument',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerDeleteFileDocumentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsEditFileDocumentChunksPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerEditFileDocumentChunksRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerEditFileDocumentChunksRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/EditFileDocumentChunks',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerEditFileDocumentChunksRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsGetFileDocumentChunkIdsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentChunkIdsRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentChunkIdsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/GetFileDocumentChunkIds',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentChunkIdsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsGetFileDocumentChunksPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentChunksRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentChunksRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/GetFileDocumentChunks',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentChunksRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsGetFileDocumentInformationPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentInformationRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentInformationRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/GetFileDocumentInformation',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentInformationRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsGetFileDocumentListPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentListRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentListRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/GetFileDocumentList',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetFileDocumentListRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsGetProcessFileDocumentStatusPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetProcessFileDocumentStatusRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetProcessFileDocumentStatusRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/GetProcessFileDocumentStatus',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetProcessFileDocumentStatusRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsSearchDocumentPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerSearchDocumentRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerSearchDocumentRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/SearchDocument',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerSearchDocumentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsStartFileDocumentWorkerAutoLoadPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerStartFileDocumentWorkerAutoLoadRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerStartFileDocumentWorkerAutoLoadRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/StartFileDocumentWorkerAutoLoad',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerStartFileDocumentWorkerAutoLoadRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubDocumentsStartFileDocumentWorkerPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerStartFileDocumentWorkerRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerStartFileDocumentWorkerRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/Documents/StartFileDocumentWorker',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerStartFileDocumentWorkerRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubIntelligentHubConfigsGetAiFeatureSettingPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetAiFeatureSettingRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetAiFeatureSettingRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/IntelligentHubConfigs/GetAiFeatureSetting',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetAiFeatureSettingRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubIntelligentHubConfigsGetConfigPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/IntelligentHub/IntelligentHubConfigs/GetConfig',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubIntelligentHubConfigsGetFeatureUsageStatisticsPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/IntelligentHub/IntelligentHubConfigs/GetFeatureUsageStatistics',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubIntelligentHubConfigsUpdateAiFeatureSettingPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerUpdateAiFeatureSettingRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerUpdateAiFeatureSettingRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/IntelligentHubConfigs/UpdateAiFeatureSetting',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerUpdateAiFeatureSettingRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubIntelligentHubConfigsUpdateConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerUpdateConfigRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerUpdateConfigRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/IntelligentHubConfigs/UpdateConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerUpdateConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubKnowledgeBasesGetKnowledgeBaseEntriesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetKnowledgeBaseEntriesRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetKnowledgeBaseEntriesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/KnowledgeBases/GetKnowledgeBaseEntries',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetKnowledgeBaseEntriesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubKnowledgeBasesGetKnowledgeBaseEntryPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerGetKnowledgeBaseEntryRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerGetKnowledgeBaseEntryRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/KnowledgeBases/GetKnowledgeBaseEntry',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerGetKnowledgeBaseEntryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubKnowledgeBasesLoadFileDocumentChunksToKnowledgeBasePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerLoadFileDocumentChunksToKnowledgeBaseRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerLoadFileDocumentChunksToKnowledgeBaseRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/KnowledgeBases/LoadFileDocumentChunksToKnowledgeBase',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerLoadFileDocumentChunksToKnowledgeBaseRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubKnowledgeBasesRemoveKnowledgeBaseEntriesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerRemoveKnowledgeBaseEntriesRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerRemoveKnowledgeBaseEntriesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/KnowledgeBases/RemoveKnowledgeBaseEntries',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerRemoveKnowledgeBaseEntriesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubRecommendedRepliesRecommendReplyPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerRecommendedReplyRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerRecommendedReplyRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/RecommendedReplies/RecommendReply',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerRecommendedReplyRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubTextEnrichmentsChangeTonePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerChangeToneRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerChangeToneRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/TextEnrichments/ChangeTone',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerChangeToneRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubTextEnrichmentsCustomPromptRewritePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerCustomPromptRewriteRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerCustomPromptRewriteRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/TextEnrichments/CustomPromptRewrite',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerCustomPromptRewriteRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubTextEnrichmentsRephrasePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerRephraseRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerRephraseRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/TextEnrichments/Rephrase',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerRephraseRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    IntelligentHubApi.prototype.intelligentHubTextEnrichmentsTranslatePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersIntelligentHubControllerTranslateRequest = _a.travisBackendControllersSleekflowControllersIntelligentHubControllerTranslateRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/IntelligentHub/TextEnrichments/Translate',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersIntelligentHubControllerTranslateRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return IntelligentHubApi;
}(runtime_1.BaseAPI));
exports.IntelligentHubApi = IntelligentHubApi;
